import React from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css';

const Sidebar = ({ openSidebar }) => {
  const activeStyle = {
    color: '#265acc',
    paddingBottom: '5px',
    borderBottom: '3px solid #265acc',
  };

  return (
    <nav className='navbar'>
      <div className='nav_icon' onClick={openSidebar}>
        <i className='fa fa-bars'></i>
      </div>
      <div className='navbar_left'>
        <NavLink to='/home' activeStyle={activeStyle}>
          Dashboard
        </NavLink>
        <NavLink to='/students' activeStyle={activeStyle}>
          Students
        </NavLink>
      </div>
    </nav>
  );
};

export default Sidebar;
